// src/Views/HomePage.js

import React, { useState, useEffect, useRef } from 'react';
import Header from './Header';
import './HomePage.css';
import '../reset.css';
import Intro from './Intro';
import placeholder from '../Assets/images/HeaderBackground.jpeg';
import Articles from './Articles';

const quotesLeftUp = [
  "Design|is|intelligence|made|visible.",
  "Simplicity|is|the|ultimate|sophistication.",
  "Every|great|design|begins|with|an|even|better|story.",
  "Design|is|thinking|made|visual.",
  "Creativity|is|nothing|but|a|mind|set|free."
];

const quotesLeftDown = [
  "Good|design|is|good|business.",
  "Less,|but|better.",
  "People|ignore|design|that|ignores|people.",
  "Design|creates|culture.|Culture|shapes|values.|Values|determine|the|future.",
  "An|intuitive|user|experience|is|the|key|to|success."
];

const quotesRightUp = [
  "Functionality|over|aesthetics.",
  "Minimalism|is|the|ultimate|form|of|sophistication.",
  "A|user|interface|is|like|a|joke,|if|you|have|to|explain|it,|it’s|bad.",
  "The|best|products|do|more|with|less.",
  "Design|adds|value|faster|than|it|adds|cost."
];

const quotesRightDown = [
  "Users|ignore|design|that|ignores|users.",
  "A|good|user|experience|is|invisible.",
  "Design|is|the|silent|ambassador|of|your|brand.",
  "Technology|over|technique|produces|emotionless|design.",
  "Great|UX|makes|complexity|disappear."
];

const ScrollingText = ({ quotes, direction, position }) => {
  return (
    <div className={`scrolling-text ${direction} ${position}`}>
      <div className="scrolling-content">
        {quotes.map((quote, index) => (
          <div key={index} className="quote">
            {quote.split('|').map((word, wordIndex) => (
              <div key={wordIndex} className="word">
                {word.split('').map((letter, letterIndex) => (
                  <p key={letterIndex} className="letter">{letter}</p>
                ))}
                <p className="separator">-</p>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

const HomePage = () => {
  const articlesRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      document.querySelectorAll('.scrolling-text.up .scrolling-content').forEach(el => {
        el.style.transform = `translateY(${window.scrollY * 0.3}px)`;
      });
      document.querySelectorAll('.scrolling-text.down .scrolling-content').forEach(el => {
        el.style.transform = `translateY(-${window.scrollY * 0.3}px)`;
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToArticles = () => {
    articlesRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="homepage">
      <div className="background-image" style={{ backgroundImage: `url(${placeholder})` }}></div>
      <Intro scrollToArticles={scrollToArticles} />
      <ScrollingText quotes={quotesLeftUp} direction="left" position="up" />
      <ScrollingText quotes={quotesLeftDown} direction="left" position="down" />
      <ScrollingText quotes={quotesRightUp} direction="right" position="up" />
      <ScrollingText quotes={quotesRightDown} direction="right" position="down" />
      <div ref={articlesRef}>
        <Articles />
      </div>
    </div>
  );
};

export default HomePage;
